import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=177b3fe2&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177b3fe2')) {
      api.createRecord('177b3fe2', component.options)
    } else {
      api.reload('177b3fe2', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=177b3fe2&", function () {
      api.rerender('177b3fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/account/profile.vue"
export default component.exports